import React, { useEffect, useRef, useState } from 'react';
import { XIcon } from 'lucide-react';
import { liveNotifications } from '../data/content';
const randomBetween = (min: number, max: number) => Math.round(min + Math.random() * (max - min));
export function LiveToast() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const timeoutRef = useRef<number | undefined>(undefined);
  useEffect(() => {
    if (isDismissed) return;
    const schedule = (delay: number, next: () => void) => {
      timeoutRef.current = window.setTimeout(next, delay);
    };
    const show = () => {
      setIsVisible(true);
      // Visible between 6 and 8 seconds.
      schedule(randomBetween(6000, 8000), hide);
    };
    const hide = () => {
      setIsVisible(false);
      // New notification every 25 to 40 seconds.
      schedule(randomBetween(19000, 32000), () => {
        setIndex(prev => (prev + 1) % liveNotifications.length);
        show();
      });
    };
    schedule(4000, show);
    return () => window.clearTimeout(timeoutRef.current);
  }, [isDismissed]);
  if (isDismissed) return null;
  const item = liveNotifications[index];
  return <div aria-live="polite" className={`fixed bottom-4 left-4 right-4 z-[100] transition-[transform,opacity] duration-300 ease-out sm:right-auto sm:max-w-sm ${isVisible ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'}`} data-id="element-105" data-mp="33jglfe2uevr9">
      <div className="flex items-start gap-3 rounded-r-xl border-y border-r border-white/10 border-l-4 border-l-gold-500 bg-ink-700 p-3.5 shadow-[0_16px_40px_rgba(0,0,0,0.65)]" data-id="element-106" data-mp="2ps221650wsjo">
        <span aria-hidden="true" className="mt-1.5 h-2 w-2 shrink-0 animate-livePulse rounded-full bg-gold-500" data-id="element-107" data-mp="2fwi4ygeq3ntc" />
        <div className="min-w-0" data-id="element-108" data-mp="26uhblumm1lwy">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.16em] text-gold-500" data-id="element-109" data-mp="26u8yq2qhmglr">
            Compra verificada
          </p>
          <p className="mt-1 text-[13px] font-semibold leading-snug text-white" data-id="element-110" data-mp="1w82jn9vsu77j">
            {item.name} de {item.city} compró {item.product}
          </p>
          <p className="mt-0.5 text-[11px] text-neutral-500" data-id="element-111" data-mp="1n9h4lopjdabi">{item.time}</p>
        </div>
        <button type="button" onClick={() => setIsDismissed(true)} aria-label="Cerrar notificación" className="ml-auto shrink-0 rounded-full p-1 text-neutral-500 transition-colors duration-150 hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400" data-id="element-112" data-mp="1s7a7o8vjlo7k">
          <XIcon className="h-4 w-4" data-id="element-113" data-mp="267ba3srgh3p5" />
        </button>
      </div>
    </div>;
}